import { Switch } from 'antd';
import React from 'react';

export default function Notification() {
    return (
        <div>
            <div className='border rounded-lg p-4'>
                <p className='font-semibold text-lg border-b pb-3'>Notification</p>
                <div className='flex items-center gap-4 mt-5'>
                    <Switch /><p>I send or receive digital currency.</p>
                </div>
                <div className='flex items-center gap-4 mt-5'>
                    <Switch /><p>There are recommendation for my account.</p>
                </div>
            </div>
        </div>
    )
}